import { mapActions } from "../reducer";

import { MapState } from '../../types';

export const updateSelectedPoint = (
  value: MapState['selectedPoint']
) => mapActions.setSelectedPoint(value);
